import React, { useEffect, useRef, useState } from "react";
import { makeAjax, respStatus, showMessage, url } from "../../helpers/global_helper";
import { useNavigate, useLocation } from "react-router-dom";
import { MdOutlineArrowBackIos } from "react-icons/md";
import CloseIcon from "../../../src/assets/images/icons/close_icon.svg"

const Promotion = (props) => {
    const { onClose, idBanner } = props;

    const location = useLocation();
    const { id, activeState } = location.state || {};
    const [banners, setBanners] = useState([]);
    const [currentActive, setCurrentActive] = useState(activeState || id || idBanner || null);
    const activeRef = useRef(null);
    const [htmlData, setHtmlData] = useState('');


    useEffect(() => {
        const currentDate = new Date().toISOString().split("T")[0];

        makeAjax(url.PLAYER_API.getPromoBanner, { date: currentDate }, url.PLAYER_MS_EXT).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage(response);
                return;
            }
            setBanners(response.data);
        });
    }, []);

    useEffect(() => {
        if (banners.length > 0 && currentActive) {
            setTimeout(() => {
                if (activeRef.current) {
                    activeRef.current.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
        }
    }, [banners, currentActive,htmlData]);


    const handleMoreInfoClick = (id) => {
        setCurrentActive((prevActive) => (prevActive === id ? null : id));
    };


    useEffect(() => {
        // Inject CSS for list styles
        const style = document.createElement('style');
        style.innerHTML = `
            /* Styling for unordered list (ul) items */
             ul {
                list-style-type: disc !important;
                padding-left: 20px;
                }
            li {
                color: #FFFFFF !important; /* Set the text color to white */
            }
    
            /* Styling for paragraph tags */
            p {
                color: #FFFFFF !important;
            }
    
            /* Styling for span tags */
            /* Ensure the bullet points of ul lists are white */
            ul li::marker {
                color: #FFFFFF !important;
            }
    
            /* Styling for ordered lists (numbered lists) */
            ol {
                list-style-type: decimal !important; /* Use decimal numbering (1, 2, 3...) */
                padding-left: 20px !important; /* Add some indentation */
            }
    
            ol li {
                color: #FFFFFF !important; /* Ensure ordered list items are white */
            }
        `;
        document.head.appendChild(style);
    
        const currentDate = new Date().toISOString().split("T")[0];
    
        makeAjax(
            url.PLAYER_API.getPromoBanner,
            { date: currentDate },
            url.PLAYER_MS_EXT
        ).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage(response);
                return;
            }
            setBanners(response.data);
           
             
            // Store HTML data for each banner individually
            const newHtmlData = {};
            response.data.forEach((banner) => {
                newHtmlData[banner.id] = banner.body || ""; // Assuming 'body' holds the HTML content
            });
            setHtmlData(newHtmlData);

        });
    
        return () => {
            document.head.removeChild(style);
        };
    }, []);
      

    return (
        <div className="information-container">
            <div className="information-inner">
                <div className="information-overlay" onClick={onClose}></div>
                <div className="information promotion-popup">

                    <div className="close_info" onClick={onClose}><img src={CloseIcon} alt="" /></div>
                    <div className="information-body">
                        <div className="promotion-wrapper">
                            <div className="pages_topbar">
                                <div className="page_heading">
                                    <h2>
                                        Promotion
                                    </h2>
                                </div>
                            </div>
                            <div className="promotions-container">
                                {banners.map((banner) => (
                                    (banner.flag_promotionmenu === 1) && (
                                        <div
                                            key={banner.id}
                                            className={`promotion ${currentActive === banner.id ? "active" : ""}`}
                                            id={`promo-${banner.id}`}
                                            ref={currentActive === banner.id ? activeRef : null}
                                        >
                                            <div className="promotion-banner-holder">
                                                <img
                                                    src={banner.updated_web_banner}
                                                    alt="Desktop Banner"
                                                    className="desktop_banner_img"
                                                    name={banner.flag_homepopup}
                                                    onClick={() => handleMoreInfoClick(banner.id)}
                                                />
                                            </div>
                                            <div
                                                className={`promo-content-outer ${currentActive === banner.id ? "highlight" : ""
                                                    }`}
                                                style={{
                                                    //maxHeight: currentActive === banner.id ? 1000 : 0,
                                                    //transition: "max-height 0.3s ease, background-color 0.3s ease",
                                                    height: currentActive === banner.id ? "100%" : 0,
                                                    transition: "height 0.3s ease, background-color 0.3s ease",
                                                }}
                                            >
                                                <div className="promo-content">
                                                    <div className="promotion_content_header">
                                                         <h4>Start date : {banner.date_start}</h4>
                                                        <h4>END date : {banner.date_end}</h4>
                                                    </div>
                                                    <div className="promotion-cnt">
                                                        <h2 className="promotion-heading">{banner.title}</h2>
                                                        {/* {banner.body.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, "").trim()} */}
                                                        <div dangerouslySetInnerHTML={{ __html: htmlData[banner.id] || '' }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Promotion;
